<template>  
  <div>
      <!-- <h4 class="text-danger">Variant Product Details</h4> -->
      <br>
    <div class="vx-row">        
      <div class="vx-col sm:w-1/4 w-full mb-3">
        <span class="text-primary text-sm vs-placeholder-label"> Variant Attribute </span>
        <v-select v-model="LocalVariantAttributeId" name="LocalVariantAttributeId" :value="LocalVariantAttributeId" :options="VariantAttributeIdOptions" label="text" :reduce="option => option.value" class="w-full" v-validate="'required|numeric'" > </v-select>
        <span class="text-danger text-sm" v-show="errors.has('LocalVariantAttributeId')">{{ errors.first('LocalVariantAttributeId') }}</span>
      </div>
    </div>

    <div class="vx-row">
        <vs-table :data="products">

            <template slot="thead">
                <vs-th> {{ VariantType }}</vs-th>
                <vs-th> Custom Code</vs-th>
                <vs-th> Description </vs-th>
                <vs-th> Opening Stock</vs-th>
                <vs-th> Production Cost </vs-th>
                <vs-th> Base Unit </vs-th>
                <vs-th> Sub Unit </vs-th>
                <vs-th> Conversion Rate </vs-th>
                <!-- <vs-th>
                    <button type='button' class="btn btn-info" @click="addNewRow">
                        <i class="fas fa-plus-circle"></i>
                    </button>
                </vs-th> -->
            </template>

            <vs-tr v-for="(VariantProduct, k) in LocalVariantProducts" :key="k">
                <vs-td>
                    <vs-input class="box-size" style="--size: 100px;" v-model="VariantProduct.VariantAttributeName" v-validate="'required'" name="VariantAttributeName" />
                    <span class="text-danger text-sm" v-show="errors.has('VariantAttributeName')">{{ errors.first('VariantAttributeName') }}</span>
                </vs-td>
                <vs-td>
                    <vs-input class="box-size" style="--size: 100px;" placeholder="Custom Code" v-model="VariantProduct.CustomCode" v-validate="'required'" name="CustomCode" :readonly="true" />
                    <span class="text-danger text-sm" v-show="errors.has('CustomCode')">{{ errors.first('CustomCode') }}</span>
                </vs-td>
                <vs-td>
                    <vs-input class="box-size" style="--size: 100px;" placeholder="Description" v-model="VariantProduct.ProductDescription" v-validate="'required'" name="ProductDescription" />
                    <span class="text-danger text-sm" v-show="errors.has('ProductDescription')">{{ errors.first('ProductDescription') }}</span>
                </vs-td>
                <vs-td>
                    <vs-input class="box-size" style="--size: 100px;" v-model="VariantProduct.OpeningStock" v-validate="'required|numeric|min_value:0'" name="OpeningStock" />
                    <span class="text-danger text-sm" v-show="errors.has('OpeningStock')">{{ errors.first('OpeningStock') }}</span>
                </vs-td>
                <vs-td>
                    <vs-input class="box-size" style="--size: 100px;" v-model="VariantProduct.ProductionCost"  name="ProductionCost" v-validate="'required|numeric|min_value:0'" />
                    <span class="text-danger text-sm" v-show="errors.has('ProductionCost')">{{ errors.first('ProductionCost') }}</span>
                </vs-td>
                <vs-td>                    
                    <v-select class="box-size" style="--size: 175px;" v-model="VariantProduct.UnitId" name="UnitId" :value="UnitId" :options="UnitIdOptions" label="text" :reduce="option => option.value" v-validate="'required|numeric'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('UnitId')">{{ errors.first('UnitId') }}</span>                    
                </vs-td>
                <vs-td>
                    <v-select class="box-size" style="--size: 175px;" v-model="VariantProduct.SubUnitId" name="SubUnitId" :value="SubUnitId" :options="UnitIdOptions" label="text" :reduce="option => option.value" v-validate="'required|numeric'" > </v-select>
                    <span class="text-danger text-sm" v-show="errors.has('SubUnitId')">{{ errors.first('SubUnitId') }}</span>
                </vs-td>
                <vs-td>
                    <vs-input class="box-size" style="--size: 100px;" v-model="VariantProduct.ConversionRate"  name="ConversionRate" v-validate="'required|numeric|min_value:0'" />
                    <span class="text-danger text-sm" v-show="errors.has('ConversionRate')">{{ errors.first('ConversionRate') }}</span>
                </vs-td>                                                
                <!-- <vs-td scope="row" class="trashIconContainer">
                    <button type='button' class="btn btn-info" @click="addNewRow">
                        <i class="fas fa-plus-circle"></i>
                    </button>
                    <button type='button' class="btn btn-info" @click="deleteRow(k, VariantProduct)">
                        <i class="far fa-trash-alt"></i>
                    </button>
                </vs-td> -->
            </vs-tr>

        </vs-table>
    </div>
  </div>
</template>

<script>
import { Validator } from 'vee-validate';
import common from '../../Common.vue'
import vSelect from 'vue-select'

const dict = {
    custom: {      
        VariantType: { required : 'Variant Type should not be empty', },
        VariantAttributeName: {
            required : 'Variant Name should not be empty',
        },        
        CustomCode: {
            required : 'Custom Code should not be empty',
        },
        ProductDescription: {
            required : 'Product Description Code should not be empty',
        },        
        OpeningStock: {
            required : 'Opening Stock should not be empty',
            numeric: 'Opening Stock is valid', 
            min_value: 'Opening Stock should be greater than or equal to 0', 
        },
        ProductionCost: {
            required : 'Production Cost should not be empty',
            numeric: 'Production Cost is valid', 
            min_value: 'Production Cost should be greater than or equal to 0', 
        },
        UnitId: {
            required : 'Product Base Unit should not be empty',
            numeric: 'Select valid Product Base Unit', 
        },
        SubUnitId: {
            required : 'Product Sub Unit should not be empty',
            numeric: 'Select valid Product Sub Unit', 
        },
        ConversionRate: {
            required : 'Convertion Rate should not be empty',
            numeric: 'Select valid Convertion Rate', 
        },                
    }
};

// register custom messages
Validator.localize('en', dict);

export default {
    mixins: [common],
    components: {
        'v-select': vSelect,
    },
    props: {
        variantIndex: {
            type: Number,
            required: true,
        }        
    },    
    data () {
      return {
        products: {},

        VariantAttributeIdOptions:[
            { "value": '', "text": '--Select Attribute--' },
            { "value": 1, "text": 'Weight' },
        ],
        VariantType : 'Variant Type',
        StoreVariantAttributeId: this.$store.state.product.dataArray[this.variantIndex].VariantAttributesId,
        LocalVariantAttributeId: '',
        UnitId:'',
        SubUnitId:'',
        UnitIdOptions: [],

        StoreVariantProducts: this.$store.state.product.dataArray[this.variantIndex].VariantProducts,        
        LocalVariantProducts: [],

      }
    },
    computed: {
        showProductVariantTable: {
            type: Boolean,
            required: true,
        },
        allProducts(){
            return this.$store.getters['product/dataList'];
        },
    },
    methods: {

        deleteRow(index, VariantProduct) {
            console.log('deleteRow called');
            console.log('index='+index+', VariantProduct='+JSON.stringify(VariantProduct));
            /*
            var idx = this.LocalVariantProducts.indexOf(VariantProduct);
            console.log(idx, index);
            */
            if (index > -1) {
                this.LocalVariantProducts.splice(index, 1);
            }
            this.calculateTotal();
            
        },
        checkCustomCode(index, VariantProduct) {
            console.log('checkCustomCode called');
            console.log('index='+index+', VariantProduct='+JSON.stringify(VariantProduct));
            var temp_code=VariantProduct.CustomCode;
            console.log('temp_code='+temp_code);
            console.log('allProducts='+JSON.stringify(this.allProducts));
            var idx = this.allProducts.map(e => e.ProductCustomCode).indexOf(temp_code);
            console.log('idx='+idx);            
            if (idx >= 0) {                
                var message='Product custom code is already exist';
                this.errorMessage(message);
                this.LocalVariantProducts[index].CustomCode = '';
                // this.deleteRow(index, VariantProduct);
            }
            /*
            var idx = this.LocalVariantProducts.indexOf(VariantProduct);
            console.log(idx, index);
            */
            
        },        
        addNewRow() {
            this.LocalVariantProducts.push({
                VariantAttributeName: '',
                CustomCode: '',
                OpeningStock: 0,
                ProductionCost: 0,
                UnitId : '',
                SubUnitId : '',
                ConversionRate : 1,
            });
        }        
    },
    beforeMount() {
        if (!this.$session.exists()) {
            console.log('your session is expired');
            this.$router.push('/');      
        }else{

            const token=this.$session.get('token');
            console.log('token='+token);

            this.LocalVariantAttributeId = this.StoreVariantAttributeId;
            this.LocalVariantProducts = this.StoreVariantProducts;
            
            var selectbox1_source = 'LocalVariantAttributeId'
            var selectbox1_destination = 'VariantAttributeIdOptions'
            var selectbox1_url = 'lib/api/data/get_product_variant_attribute_options'
            var selectbox1_conditions_array = {
                'product_variant_attributes_id > ': 1
            }
            this.getSelectBoxOptions(selectbox1_source, selectbox1_destination, selectbox1_conditions_array, selectbox1_url)

            var selectbox2_source = 'UnitId'
            var selectbox2_destination = 'UnitIdOptions'
            var selectbox2_url = 'lib/api/data/get_product_unit_options'
            var selectbox2_conditions_array = {
                'product_unit_id > ': 0
            }
            this.getSelectBoxOptions(selectbox2_source, selectbox2_destination, selectbox2_conditions_array, selectbox2_url)
            
        }
    },
    watch: {        
        LocalVariantAttributeId: function(){
            var temp1=this.LocalVariantAttributeId.toString();
            var temp2=this.VariantAttributeIdOptions;
            console.log('watch LocalVariantAttributeId='+temp1+', VariantAttributeIdOptions='+JSON.stringify(temp2));
            var index = this.VariantAttributeIdOptions.map(e => e.value).indexOf(temp1);
            console.log('temp1='+temp1+', index='+index+', record='+JSON.stringify(temp2[index]));
            if (temp1 != "") {
                var temp3=temp2[index].text;
                console.log('temp3='+temp3);
                this.VariantType=temp3;
            }else{
                this.VariantType="Variant Type";
            }
            this.$parent.VariantAttributeId=this.LocalVariantAttributeId;            
        },
        LocalVariantProducts: function () {
            console.log('watch LocalVariantProducts='+JSON.stringify(this.LocalVariantProducts));
            this.$parent.Products=this.LocalVariantProducts;
        },
    },
}


</script>

<style scoped lang="css">
.box-size{
    width: var(--size);
}
</style>
